import {FetchCriteriaModel} from 'lib/ng2-sapmp/src/ui-components/custom-grid';

export class LicensesBuyProductModel {
  class: string;
  fetchCriteria: FetchCriteriaModel;
  serviceOfferCodes: Array<string>;
  serviceStatus: string;

  constructor() {
      this.class = undefined;
      this.serviceOfferCodes = undefined;
      this.serviceStatus = undefined;
  }
}
